// RESONATE_LEGAL_PAGES_V1
// RESONATE_AGENCIES_V2 - multi-column with For agencies column
const COLUMNS = [
  {
    label: "Product",
    links: [
      { label: "Features", href: "/#features" },
      { label: "Pricing", href: "/#pricing" },
      { label: "FAQ", href: "/faq" },
    ],
  },
  {
    label: "For agencies",
    links: [
      { label: "Agency plan", href: "/agencies#agency-pricing" },
      { label: "Partner Program", href: "/agencies#partner-program" },
      // RESONATE_AGENCIES_V2 - "Find a ghostwriter" cross-link removed per request
    ],
  },
  {
    label: "Resources",
    links: [
      { label: "Blog", href: "/blog" },
      { label: "Done-for-you Marketplace", href: "/done-for-you" },
    ],
  },
  {
    label: "Company",
    links: [
      { label: "About", href: "/about" },
      { label: "Security", href: "/security" },
      { label: "Privacy", href: "/privacy" },
      { label: "Terms", href: "/terms" },
    ],
  },
];

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#111827] py-16 md:py-20">
    <div className="max-w-[1240px] mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-10 md:gap-8 mb-12">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <img
              src="/brand/logo.png"
              alt="Resonate logo"
              width="24"
              height="24"
              loading="lazy"
              decoding="async"
              className="h-6 w-6 object-contain"
              style={{ filter: "invert(1) opacity(0.4)" }}
              draggable="false"
            />
            <span style={{ fontFamily: "var(--f-serif)" }} className="text-[18px] text-white/55 tracking-tight">Resonate</span>
          </div>
          <p className="text-[13px] text-white/55 leading-relaxed max-w-[240px]">
            LinkedIn content that sounds like you. Ban-safe. Built for founders, agencies, and the people who actually post.
          </p>
        </div>

        {COLUMNS.map((col) => (
          <div key={col.label}>
            <div className="text-[11px] uppercase tracking-[0.18em] text-white/55 font-semibold mb-4">{col.label}</div>
            <ul className="space-y-2.5">
              {col.links.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-[13.5px] text-white/55 hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
        <span className="text-[12px] text-white/55">&copy; 2026 Resonate. All rights reserved.</span>
        <span className="text-[12px] text-white/55">getresonate.ai</span>
      </div>
    </div>
  </footer>
);
